import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  Grid,
  Checkbox,
  Typography,
  FormControl,
  InputLabel,
  FormControlLabel,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import {
  UserFields,
  AddressFields,
} from "./UserFields";
import SelectOffer from "../Renewal/Offers";
import { ClipLoader } from "react-spinners";
import { getProperPromoCode } from "./AddCSADialog";

const StyledTextField = ({ label, name, value, onChange, disabled, ...props }) => <div>
  <TextField label={label} name={name} value={value} onChange={onChange} disabled={disabled} variant="outlined" size="small" fullWidth {...props} />
</div>

const OffersComponent = ({ meterInfo, offers, setOffers, setProduct, setStep, closeDialog, setInputtedPromo, loading, submitEnrollment }) => {
  return (
    <>
      <DialogTitle>
        Select Offer
      </DialogTitle>
      <DialogContent>
        {
          loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '20px'
            }}>
              <ClipLoader sizeUnit="px" size={100} color="#ED0874" loading />
            </div>
          ) : offers.length === 0 ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '20px'
            }}>
              There are no offers available for that zip code
            </div>
          ) : (
            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <SelectOffer
                energyLevel={"2"}
                offers={offers}
                onOfferSelected={(offer) => setProduct(offer)}
                offerSelected={meterInfo?.product}
              />
            </div>
          )
        }
      </DialogContent >
      <DialogActions>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => {
            setOffers([])
            setProduct(null)
            setInputtedPromo("")
            setStep(1)
          }}
        >
          Go Back
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={meterInfo?.product === null}
          onClick={() => {
            setInputtedPromo("")
            submitEnrollment();
            closeDialog();
          }}
        >
          Add Meter
        </Button>
      </DialogActions>
    </>
  )
}

const AddMeterDialog = ({ closeDialog, parentCSA, userInfo, doFetchProductOffers, doFindMeter, submitMemberEnrollment, doGetCurrentProduct }) => {
  const meterType = parentCSA.csa_type;
  const [esiID, setEsiID] = useState("");
  const [address, setAddress] = useState(null);
  const [wantNewProduct, setWantNewProduct] = useState(false)
  const [inputtedPromo, setInputtedPromo] = useState("")
  const [offers, setOffers] = useState([])
  const [step, setStep] = useState(1)
  const [loading, setLoading] = useState(false)
  const displayUser = { company_name: parentCSA?.company_name, ...userInfo };
  const tdsp_duns = parentCSA.tdsp_duns

  function submitEnrollment() {
    let enrollMode = meterInfo.enrollMode;

    if (meterType === "tenant") {
      enrollMode = "csa"
    }

    submitMemberEnrollment({
      meterInfo: { ...meterInfo, address, enrollMode },
    });
  }

  const [meterInfo, setMeterInfo] = useState({
    meterUID: "",
    enrollMode: "switch",
    enrollmentType: "add_meter",
    requestedStartDate: new Date,
    firstAvailableDate: false,
    tdsp_name: "",
    zipcode: "",
    product: null,
    promo_code: "",
    currentProductName: "",
  });

  function updateMeter(event) {
    setMeter({ [event.target.name]: event.target.value });
  }

  function getLatestOfferByEndDate(items) {
    if (!Array.isArray(items) || items.length === 0) return null;

    return items.reduce((latest, current) => {
      const latestDate = new Date(latest.end_date);
      const currentDate = new Date(current.end_date);
      return currentDate > latestDate ? current : latest;
    });
  }

  function setMeter(props) {
    if (props.enrollMode == "movein") {
      props.firstAvailableDate = false;
    }
    setMeterInfo({
      ...meterInfo,
      ...props,
    })
  }

  async function onSetESI(e) {
    let newAddr = null;
    let newMeterProps = {
      tdsp_name: "",
      meterUID: esiID,
      zipcode: "",
      currentProductName: "",
    };
    const meter = await doFindMeter({ esi_id: esiID, tdsp_duns: tdsp_duns });
    if (meter) {
      newAddr = meter.address;
      newMeterProps.zipcode = newAddr.postal_code
      const allOffers = await doFetchProductOffers({ memberID: parentCSA.member_id, postal_code: meter.address.postal_code });
      const meterOffers = allOffers.tdsps?.find((tdsp) => tdsp.duns_number === meter.duns);
      if (meterOffers) {
        newMeterProps.tdsp_name = meterOffers.name;
      }
      const currentOffer = await doGetCurrentProduct({ memberID: parentCSA.member_id })
      if (currentOffer) {
        newMeterProps.currentProductName = getLatestOfferByEndDate(currentOffer.list)?.product_code
      }
    }
    setMeter(newMeterProps);
    setAddress(newAddr);
  }

  function validateInput() {
    return address && userInfo;
  }

  function onChangeInputtedPromo(event) {
    setInputtedPromo(event.target.value)
    setMeterInfo({
      ...meterInfo,
      promo_code: event.target.value
    })
  }

  const setProduct = (newProduct) => {

    if (!newProduct) {
      setMeterInfo({
        ...meterInfo,
        product: newProduct,
      });
    } else {

      newProduct.tdsp_duns = tdsp_duns

      setMeterInfo({
        ...meterInfo,
        product: newProduct
      });
    }
  }

  const getOffers = async (promo_code = null) => {
    setLoading(true);

    const allOffers = await doFetchProductOffers({ postal_code: meterInfo.zipcode, promo_code: promo_code });
    if (allOffers?.tdsps && allOffers?.tdsps[0]) {
      setOffers(allOffers?.tdsps[0].offers)
    } else {
      setOffers([])
    }
    setLoading(false);
  }

  useEffect(() => {
    if (step === 2) {
      getOffers(getProperPromoCode(parentCSA.csa_type, inputtedPromo))
    }
  }, [step])

  return <Dialog
    open={true}
    contentlabel="Add Meter"
    fullWidth
    maxWidth="md"
  >
    {step === 1 && <>
      <DialogTitle>
        Add Meter to CSA
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <div>
              <TextField
                onChange={(e) => {
                  const valueString = e.target.value || '';
                  setEsiID(valueString.replace(/\D/g, ''))
                }}
                label="ESI ID"
                value={esiID}
                variant="outlined"
                size="small"
                style={{ minWidth: "250px" }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={onSetESI}
                disabled={!esiID}
              >
                Set ESI ID
              </Button>
            </div>
          </Grid>
          <Grid item sm={6}>
            <StyledTextField
              label="Meter Type"
              name="meterType"
              value={meterType}
              disabled={true}
            />
          </Grid>

          {meterType != "tenant" && <>
            <Grid item sm={6}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel id="enroll-mode">Enrollment Type</InputLabel>
                <Select name="enrollMode" onChange={updateMeter} value={meterInfo.enrollMode} labelId="enroll-mode" label="Enrollment Type">
                  <MenuItem value="switch">Switch</MenuItem>
                  <MenuItem value="movein">Move In</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={6}>
              {meterInfo.enrollMode == "switch" && <>
                <FormControlLabel
                  control={<Checkbox
                    checked={meterInfo.firstAvailableDate}
                    onChange={(e) => setMeter({ firstAvailableDate: e.target.checked })}
                  />}
                  label="First Available Date"
                />
              </>}
            </Grid>
            <Grid item sm={6}>
              {meterInfo.firstAvailableDate || <>
                <DatePicker
                  value={meterInfo.requestedStartDate}
                  onChange={(date) => setMeter({ requestedStartDate: date })}
                  format="yyyy-MM-dd"
                  label="Start Date"
                  size="small"
                  autoOk
                  disablePast
                  TextFieldComponent={(props) => (
                    <TextField
                      {...props}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </>}
            </Grid>
          </>}

          <Grid item xs={12}>
            <Typography variant="h6">User Information</Typography>
          </Grid>
          <Grid item xs={12}>
            {userInfo && <UserFields userDetails={displayUser} disabled />}
          </Grid>
          {address && <>
            <Grid item xs={12}>
              <Typography variant="h6">Meter Address</Typography>
            </Grid>
            <Grid item xs={12}>
              <AddressFields address={address} disabled />
            </Grid>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <Typography variant="h6">Default Product: {meterInfo.currentProductName}</Typography>
                <FormControl variant="outlined" size="small" fullWidth style={{ marginTop: "25px" }}>
                  <InputLabel id="product-mode">Want New Product?</InputLabel>
                  <Select
                    name="productMode"
                    onChange={() => setWantNewProduct(!wantNewProduct)}
                    value={wantNewProduct}
                    labelId="product-mode"
                    label="Want New Product?"
                  >
                    <MenuItem value={false}>No</MenuItem>
                    <MenuItem value={true}>Yes</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {wantNewProduct && (
                <Grid item sm={6} xs={12} style={{ display: "flex", alignItems: "flex-end" }}>
                  <FormControl variant="outlined" size="small" fullWidth style={{ marginTop: "25px" }}>
                    <StyledTextField
                      label="Promo Code"
                      name="promo_code"
                      value={inputtedPromo}
                      onChange={onChangeInputtedPromo}
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          onClick={closeDialog}
        >
          Cancel
        </Button>
        {!wantNewProduct && <Button
          color="primary"
          disabled={!validateInput()}
          onClick={() => {
            submitEnrollment();
            closeDialog();
          }}
        >
          Add Meter
        </Button>}
        {wantNewProduct && <Button
          color="primary"
          disabled={!validateInput()}
          onClick={() => {
            setOffers([])
            setProduct(null)
            setStep(2)
          }}
        >
          Continue
        </Button>}
      </DialogActions>
    </>}

    {step === 2 && (
      <OffersComponent
        meterInfo={meterInfo}
        setOffers={setOffers}
        setProduct={setProduct}
        setStep={setStep}
        offers={offers}
        closeDialog={closeDialog}
        setInputtedPromo={setInputtedPromo}
        loading={loading}
        submitEnrollment={submitEnrollment}
      />
    )}
  </Dialog>
};

export default AddMeterDialog;
